"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetTypes = void 0;

/**
 * Module dependencies.
 */

/**
 * Export `assetTypes`.
 */
var assetTypes = {
  crypto: 'crypto',
  custom: 'custom',
  fiat: 'fiat'
};
/**
 * Export `AssetType` type.
 */

exports.assetTypes = assetTypes;